import * as moment from "moment";
export class GeneralSetting {
  id?: number;
  paramKey: string;
  paramValue: string;
  description: string;
  paramDataType: string;
  created?: moment.Moment | null;
  modified?: moment.Moment| null;
  originalValue:any;
  isEditable:boolean=false;
  static fromObjectArray(invitations: IGeneralSetting[]): GeneralSetting[] {
    return invitations.map(GeneralSetting.fromObject);
  }
  static fromObject(_obj: IGeneralSetting): GeneralSetting {
    const obj = new GeneralSetting();
    obj.id = _obj.id;
    obj.paramKey = _obj.param_key;
    obj.paramValue = _obj.param_value;
    obj.description = _obj.description;
    obj.paramDataType = _obj.param_datatype;
    obj.created = _obj.created ? moment(_obj.created) : undefined;
    obj.modified = _obj.modified ? moment(_obj.modified) : undefined;

    return obj;
  }
}

export interface  IGeneralSetting{
  id?: number;
  param_key: string;
  param_value: string;
  description: string;
  param_datatype: string;
  created?: moment.Moment;
  modified?: moment.Moment;
}


export interface IResultGeneralSetting {
  count: number;
  next: string;
  previous: string;
  results: IGeneralSetting[];
}

export class ResultGeneralSetting {
  count: number;
  next: string;
  previous: string;
  results: GeneralSetting[];

  static fromObject(result: IResultGeneralSetting): ResultGeneralSetting {
    const obj = new ResultGeneralSetting();
    obj.count = result.count;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = result.results ? GeneralSetting.fromObjectArray(result.results) : [];
    return obj;
  }
}



export class SystemStatus {
  id?: number;
  processName: string;
  statusMode: boolean;
  updatedAt?: moment.Moment;
  lastRunAt?: moment.Moment | null;
  startover: boolean;
  startoverAt?: moment.Moment | null;

  static fromObjectArray(data: ISystemStatus[]): SystemStatus[] {
    return data.map(SystemStatus.fromObject);
  }

  static fromObject(obj: ISystemStatus): SystemStatus {
    const status = new SystemStatus();
    status.id = obj.id;
    status.processName = obj.process_name;
    status.statusMode = obj.status_mode;
    status.updatedAt = obj.updated_at ? moment(obj.updated_at) : undefined;
    status.lastRunAt = obj.last_run_at ? moment(obj.last_run_at) : null;
    status.startover = obj.startover;
    status.startoverAt = obj.startover_at ? moment(obj.startover_at) : null;
    return status;
  }
}

export interface ISystemStatus {
  id?: number;
  process_name: string;
  status_mode: boolean;
  updated_at?: string;
  last_run_at?: string | null;
  startover: boolean;
  startover_at?: string | null;
}

export interface IResultSystemStatus {
  count: number;
  next: string | null;
  previous: string | null;
  results: ISystemStatus[];
}

export class ResultSystemStatus {
  count: number;
  next: string | null;
  previous: string | null;
  results: SystemStatus[];

  static fromObject(obj: IResultSystemStatus): ResultSystemStatus {
    const result = new ResultSystemStatus();
    result.count = obj.count;
    result.next = obj.next;
    result.previous = obj.previous;
    result.results = obj.results ? SystemStatus.fromObjectArray(obj.results) : [];
    return result;
  }
}
